import Vue from 'vue'
import Toasts from 'vue-toasted'


let Options = {
  theme: "outline",
  position: "bottom-center",
  duration : 5000
}
Vue.use(Toasts, Options)